import React, { useState, useEffect } from "react";
import "../navbar.scss";
import Logo from "../img/base/111.png";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavbarText,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  CardImg,
  Input,
  Label,
  Row,
  Card,
  CardBody,
  Spinner,
  Alert,
} from "reactstrap";
import { Outlet, useNavigate, Link } from "react-router-dom";
import SidebarBec from "./SidebarBec";
import Swal from "sweetalert2";
import { useAuth } from "../../utils/AuthContext";
import useIdleTimer from "../../utils/useIdleTimer";

const TIMEOUT_DURATION = 10 * 60 * 1000; // 5 minutos en milisegundos

function NavbarBec(args) {
  ///Contraseña
  const [modalContra, setModalContra] = useState(false);
  const abrirCerrarModalContra = () => {
    setModalContra(!modalContra);
  };
  ///Foto
  const [modalFoto, setModalFoto] = useState(false);
  const abrirCerrarModalFoto = () => {
    setModalFoto(!modalFoto);
  };
  ///Documento
  const [modalInsertar, setModalInsertar] = useState(false);
  const abrirCerrarModalInsertar = () => {
    setModalInsertar(!modalInsertar);
  };
  ////FECHA
  const [modalFecha, setModalFecha] = useState(false);
  const abrirCerrarModalFecha = () => {
    setModalFecha(!modalFecha);
  };
  ///link api php
  const baseUrlB = "https://bqef-bo.com/api/B/apiB.php";
  const baseUrl = "https://bqef-bo.com/api/A/apiDash.php";

  const [dataBec, setDataBec] = useState({
    id_bec: "",
    nombre: "",
    apellido: "",
    contrasena: "",
    contrasena_lit: "",
    foto: "",
    // otras propiedades si las tienes
  });

  // Estado y efectos
  const [fec, setFec] = useState([]);
  const [lista, setLista] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [imagenP, setImagenP] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  // Estado de la lista de comunicados
  const [listaCom, setListaCom] = useState([]);

  // Estado del modal y el comunicado a mostrar
  const [modalCom, setModalCom] = useState(false);
  const [comunicadoMostrado, setComunicadoMostrado] = useState(null);

  // Constantes
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Para Documento
  const [imagenDoc, setImagenDoc] = useState(null);
  const [nombreDocumento, setNombreDocumento] = useState("");
  const [isEnabled, setIsEnabled] = useState(false); // Para habilitar el botón

  ////Datos usuario Becario
  const peticionGetBec = async () => {
    setLoading(true);
    setError("");
    const BecId = sessionStorage.getItem("iduser");
    try {
      const res = await axios.get(`${baseUrlB}?action=getinfoBec&id=${BecId}`);
      const infoBecArray =
        res.data.InfoBec && Array.isArray(res.data.InfoBec)
          ? res.data.InfoBec
          : [];
      // console.log(res.data);
      if (infoBecArray.length > 0) {
        setDataBec(infoBecArray[0]);
      } else {
        setDataBec({});
      }
    } catch (error) {
      console.log(error);
      setError("Error al cargar los datos");
      mostrarMensajeError("Error al obtener datos del usuario");
    } finally {
      setLoading(false);
    }
  };

  ////Datos Fecha Entrega
  const peticionGetFecha = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${baseUrlB}?action=getinfoFec`);
      const infoFecArray =
        res.data.InfoFec && Array.isArray(res.data.InfoFec)
          ? res.data.InfoFec
          : [];
      // console.log(res.data);
      if (infoFecArray.length > 0) {
        setFec(infoFecArray[0]);
      } else {
        setFec({});
      }
    } catch (error) {
      console.log(error);
      setError("Error al cargar los datos");
      mostrarMensajeError("Error al obtener datos del usuario");
    } finally {
      setLoading(false);
    }
  };
  /////Obtener convocatoria
  const getConvocatoria = async () => {
    // setLoading(true);
    // setError("");
    try {
      const res = await axios.get(`${baseUrl}?action=getConv`);
      const receivedData =
        res.data.Convocatorias && Array.isArray(res.data.Convocatorias)
          ? res.data.Convocatorias
          : [];

      // Filtrar solo los archivos de tipo 'convocatoria'
      const convocatorias = receivedData.filter(
        (item) => item.tipo_archivo === "convocatoria"
      );

      // Obtener el último archivo de convocatoria
      const ultimoConvocatoria =
        convocatorias.length > 0
          ? convocatorias[convocatorias.length - 1]
          : null;

      // console.log(ultimoConvocatoria);

      // Si quieres guardar solo el último en el estado
      setLista(ultimoConvocatoria ? [ultimoConvocatoria] : []);
    } catch (error) {
      // setError("Error al cargar los datos");
    } finally {
      // setLoading(false);
    }
  };
  /////Obtener comunicado
  const getComunicado = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${baseUrl}?action=getConv`);
      const receivedData =
        res.data.Convocatorias && Array.isArray(res.data.Convocatorias)
          ? res.data.Convocatorias
          : [];

      // Filtrar solo los archivos de tipo 'convocatoria'
      const comunicados = receivedData.filter(
        (item) => item.tipo_archivo === "comunicado"
      );

      // Obtener el último archivo de convocatoria
      const ultimoComunicado =
        comunicados.length > 0 ? comunicados[comunicados.length - 1] : null;

      // console.log(ultimoConvocatoria);

      // Si quieres guardar solo el último en el estado
      setListaCom(ultimoComunicado ? [ultimoComunicado] : []);
    } catch (error) {
      setError("Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  };
  /////Modificar Constraseña Becario
  const peticionPutContra = async () => {
    const dataToSend = {
      id_bec: dataBec.id_bec,
      contrasena: dataBec.contrasena,
      usu_modificacion: dataBec.id_bec,
    };

    // console.log("id_bec:", dataBec.id_bec);
    // console.log("Datos a enviar:", dataToSend);

    try {
      // const response =
      await axios.put(`${baseUrlB}?action=updateContraBec`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log("Respuesta del servidor:", response.data);

      // Actualizar el estado dataAdm con la nueva contraseña
      setDataBec((prevDataAdm) => ({
        ...prevDataAdm,
        contrasena: dataBec.contrasena,
      }));
      peticionGetBec();
      abrirCerrarModalContra();
      mostrarAlertaPA();
    } catch (error) {
      console.error("Error en peticionPut:", error);
    }
  };

  /////Modificar Foto Becario
  const peticionPuti = async () => {
    if (!imagenP) {
      alert("Por favor selecciona una imagen");
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(imagenP);
    reader.onload = async () => {
      const base64Data = reader.result.split(",")[1]; // Extraer solo la parte base64

      const dataToSend = {
        id_bec: dataBec.id_bec,
        archivo_foto: base64Data,
        usu_modificacion: dataBec.id_bec, // O el usuario que realiza la modificación
      };

      try {
        await axios.put(`${baseUrlB}?action=updateFotoBec`, dataToSend, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        // Actualizar estado y cerrar modal
        setImagenP((prevDataAdm) => ({
          ...prevDataAdm,
          archivo_foto: base64Data,
        }));
        peticionGetBec();
        abrirCerrarModalFoto();
        mostrarAlertaF();
      } catch (error) {
        console.error("Error en peticionPut:", error);
      }
    };
  };
  ////sesion cierre
  const { isAuthenticated, logoutSubmit } = useAuth();
  const [remainingTime, setRemainingTime] = useState(TIMEOUT_DURATION);

  // Configurar el temporizador de inactividad
  useIdleTimer(TIMEOUT_DURATION, logoutSubmit, setRemainingTime);

  // Iniciar el temporizador solo si el usuario está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      setRemainingTime(TIMEOUT_DURATION); // Reiniciar el tiempo restante
    } else {
      setRemainingTime(TIMEOUT_DURATION); // Reiniciar el tiempo si el usuario no está autenticado
    }
  }, [isAuthenticated]);

  // Función para formatear el tiempo restante en minutos y segundos
  const formatTime = (time) => {
    const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((time % (1000 * 60)) / 1000);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };
  //
  const navigate = useNavigate();
  // LOGOUT
  const logoutSub = () => {
    // Mostrar alerta de confirmación
    Swal.fire({
      title: "¿Está seguro?",
      text: "¿Desea cerrar sesión?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, cerrar sesión!",
    }).then((result) => {
      if (result.isConfirmed) {
        sessionStorage.clear(); // Limpia la sesión
        logoutSubmit(); // Actualiza el estado de autenticación
        navigate("/"); // Redirige a la página de inicio
      }
    });
  };
  ////
  const toggle = () => setIsOpen(!isOpen);
  ///Cargar Informe Becario
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImagenDoc(e.target.files[0]);
      setIsEnabled(true);
    } else {
      setImagenDoc(null);
      setIsEnabled(false);
    }
  };

  const validarNombreDocumento = (e) => {
    setNombreDocumento(e.target.value);
  };
  ////Cargar Documento
  const addDocumento = async () => {
    if (!imagenDoc) {
      alert("Por favor selecciona un documento");
      return;
    }

    if (!nombreDocumento.trim()) {
      alert("Por favor ingresa el nombre del documento");
      return;
    }

    const reader = new FileReader();

    reader.onload = async () => {
      try {
        const base64Data = reader.result.split(",")[1];

        const dataToSend = {
          id_bec: dataBec.id_bec,
          nom_doc: nombreDocumento,
          nom_usu: dataBec.nombre + " " + dataBec.apellido,
          archivo_doc: base64Data,
          usu_creacion: dataBec.id_bec,
        };

        await axios.post(`${baseUrlB}?action=cargarDocumento`, dataToSend, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        mostrarAlertaC();
        abrirCerrarModalInsertar();

        // Limpiar campos
        setImagenDoc(null);
        setNombreDocumento("");
        setIsEnabled(false);
      } catch (error) {
        console.error("Error al cargar documento:", error);
        mostrarAlertaD();
      }
    };

    reader.onerror = () => {
      console.error("Error al leer el archivo");
      alert("Error al leer el archivo");
    };

    reader.readAsDataURL(imagenDoc);
  };

  ////Descargar PDF
  const handleDescargarPdf = async () => {
    var link = document.createElement("a");
    link.setAttribute(
      "href",
      "data:application/pdf;base64," + selectedItem.archivo_com
    );
    link.setAttribute("download", selectedItem.nom_doc);
    link.click();
  };

  useEffect(() => {
    peticionGetBec();
    getConvocatoria();
    getComunicado();
    peticionGetFecha();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // También, cuando listaCom cambie, asignar el primero para mostrar
  useEffect(() => {
    if (listaCom.length > 0) {
      setComunicadoMostrado(listaCom[0]);
    } else {
      setComunicadoMostrado(null);
    }
  }, [listaCom]);
  ////ALERTAS
  const mostrarMensajeError = (mensaje) => {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: mensaje,
      timer: 5000, // cerrar automáticamente el mensaje de error después de 5 segundos
    });
  };
  const mostrarAlertaC = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Documento Cargado.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaD = () => {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Error Carga Documento.",
      timer: 5000,
    });
  };
  const mostrarAlertaF = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Foto Actualizada",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaPA = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Constraseña Actualizada",
      timer: 5000,
      icon: "success",
    });
  };
  ////
  const handleSelectItem = (item) => {
    setSelectedItem(item);
  };
  ////Boton Cerrar
  const closeBtn = () => {
    setSelectedItem(null);
  };
  /////
  const [alertVisible, setAlertVisible] = useState(true);
  const onDismiss = () => setAlertVisible(false);
  ///comunicado
  const [alertVisible2, setAlertVisible2] = useState(true);
  const onDismiss2 = () => setAlertVisible2(false);
  ///
  const abrirCerrarModalProyec = () => {
    // Aquí va el código para abrir el modalProy
    setModalFecha(!modalFecha);
  };
  // Función para abrir el modal desde el alert
  const abrirModalDesdeAlert = () => {
    setModalCom(!modalCom);
  };
  ////Modal VER MANUAL USUARIO
  const [modalVerManual, setModalVerManual] = useState(false);
  const abrirCerrarModalVerManual = () => {
    setModalVerManual(!modalVerManual);
  };
  ///pdf ver manual
  const handleDownloadPdf = () => {
    const link = document.createElement("a");
    link.href = require("../../Pages/Admin/documentos/manuales/MANUAL USUARIO BECARIO.pdf");
    link.download = "MANUAL USUARIO BECARIO.pdf";
    link.click();
  };
  // Definir un objeto de validación para contraseña
  const validation = {
    contrasena: {
      regex:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%?&%"*#¡¿])[A-Za-z\d@$!%?&%"*#¡¿]{8,}$/,
      isValid: true,
    },
  };

  const [isValid, setIsValid] = useState({
    contrasena: false,
  });
  ///
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataBec((prevState) => ({ ...prevState, [name]: value }));

    const isValidValue = validation[name].regex.test(value);
    setIsValid((prevState) => ({ ...prevState, [name]: isValidValue }));
  };
  ////Carga
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner color="primary" />
        Cargando...
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }
  return (
    <div>
      <Navbar expand="md" {...args}>
        {/* Sidebar (si aplica) */}
        <SidebarBec />

        {/* Logo y marca */}
        <Nav>
          <Link to="/Becario/Becario" className="navbar-brand text-light">
            <img
              src={Logo}
              alt="logo"
              className="me-2"
              style={{
                height: 60,
                width: 120,
              }}
            />
          </Link>
        </Nav>
        {/* Toggler para dispositivos móviles */}
        <NavbarToggler onClick={toggle} />

        {/* Contenido colapsable */}
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto" navbar>
            {/* Temporizador de inactividad (solo si está autenticado) */}
            {isAuthenticated && (
              <NavbarText className="text-light me-3">
                Cierre de sesión en: {formatTime(remainingTime)}
              </NavbarText>
            )}

            {/* Botón Enviar Información */}
            <NavItem className="me-3">
              <Button
                style={{ marginTop: "5px" }}
                color="warning"
                onClick={abrirCerrarModalInsertar}
              >
                <FaIcons.FaPlus /> ENVIAR INF
              </Button>
            </NavItem>

            {/* Foto del usuario si existe */}
            <NavItem className="me-3">
              {dataBec.foto && (
                <CardImg
                  src={"data:image/png;base64," + dataBec.foto}
                  alt="Foto del Becario"
                  className="rounded-circle"
                  style={{
                    height: 50,
                    width: 50,
                    marginTop: "2px",
                    border: "5px solid rgba(10, 49, 67, 1)",
                    cursor: "pointer", // Añadido para indicar que es clickeable
                  }}
                  onClick={abrirCerrarModalFoto}
                />
              )}
            </NavItem>

            {/* Nombre del usuario */}
            <NavbarText className="text-light me-3">
              {dataBec.nombre} {dataBec.apellido}
            </NavbarText>

            {/* Menú desplegable */}

            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret className="text-light">
                MENÚ
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem onClick={abrirCerrarModalVerManual}>
                  Instrucciones
                </DropdownItem>
                {lista.map((item) => (
                  <DropdownItem
                    key={item.id_com}
                    onClick={() => handleSelectItem(item)}
                  >
                    Postulacion
                  </DropdownItem>
                ))}
                <DropdownItem href="http://www.bqef.org/" target="_blank">
                  Sobre Nosotros...
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={abrirCerrarModalFoto}>Foto</DropdownItem>
                <DropdownItem onClick={abrirCerrarModalContra}>
                  Cambiar Contraseña
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={logoutSub}>Salir</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>

      {/* Primer alerta */}
      <Alert
        color="danger"
        isOpen={alertVisible}
        toggle={onDismiss}
        style={{
          maxWidth: "80vw",
          position: "absolute",
          top: "50%",
          right: "0%",
          transform: "translate(-50%, -50%)",
          animation: "slideIn 1s forwards",
          zIndex: 1000,
        }}
      >
        <span
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          onClick={() => abrirCerrarModalProyec()}
        >
          <FaIcons.FaExclamationCircle />
          &nbsp; F. Entrega &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </Alert>

      {/* Segunda alerta */}
      <Alert
        color="info"
        isOpen={alertVisible2}
        toggle={onDismiss2}
        style={{
          maxWidth: "80vw",
          position: "absolute",
          top: "70%",
          right: "0%",
          transform: "translate(-50%, -50%)",
          animation: "slideIn 1s forwards",
          zIndex: 1000,
        }}
      >
        <span
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          onClick={abrirModalDesdeAlert}
        >
          <FaIcons.FaCommentAlt />
          &nbsp; Comunicado &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </Alert>

      {/* MODAL INFORME */}
      <Modal isOpen={modalInsertar} toggle={abrirCerrarModalInsertar}>
        <ModalHeader className="header_mo">Cargar documento</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <Label>Nombre documento: </Label>
            <br />
            <Input
              type="text"
              className="form-control"
              value={nombreDocumento}
              onChange={validarNombreDocumento}
            />
            <br />
            <Label>Usuario: </Label>
            <br />
            <Input
              type="text"
              className="form-control"
              value={`${dataBec.nombre} ${dataBec.apellido}`}
              disabled
            />
            <br />
            <Label>ID Usuario: </Label>
            <br />
            <Input
              type="text"
              className="form-control"
              value={dataBec.id_bec}
              disabled
            />
            <br />
            <Label>Documento: </Label>
            <br />
            <Input
              type="file"
              className="form-control"
              accept="application/*"
              onChange={handleFileChange}
            />
            <br />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            size="lg"
            onClick={addDocumento}
            disabled={!isEnabled || !nombreDocumento.trim()}
          >
            Cargar
          </Button>
          <Button color="danger" size="lg" onClick={abrirCerrarModalInsertar}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* MODAL CONTRASEÑA */}
      <Modal isOpen={modalContra} toggle={abrirCerrarModalContra}>
        <ModalHeader className="header_mo">Editar Contraseña</ModalHeader>
        <ModalBody>
          <Label>Clave Actual:</Label>
          <Input
            disabled
            type="text"
            className="form-control"
            value={dataBec.contrasena_lit || "No disponible"}
          />
          <Label>Nueva Clave: </Label>
          <Input
            type="text"
            className="form-control"
            name="contrasena"
            onChange={handleChange}
          />
          {!isValid.contrasena && (
            <span style={{ color: "red" }}>
              La contraseña debe tener al menos 8 caracteres, incluyendo
              mayúsculas, minúsculas, números y caracteres especiales
            </span>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            size="lg"
            onClick={() => peticionPutContra()}
            disabled={!isValid.contrasena}
          >
            Guardar
          </Button>
          {"   "}
          <Button
            color="danger"
            size="lg"
            onClick={() => abrirCerrarModalContra()}
          >
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* MODAL FOTO */}
      <Modal isOpen={modalFoto} toggle={abrirCerrarModalFoto}>
        <ModalHeader className="header_mo">Modificar Foto Perfil</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Nombre documento: </label>
            <br />
            {dataBec.foto && (
              <div>
                <CardImg
                  className="rounded-circle"
                  alt="Card image cap"
                  src={"data:image/png;base64," + dataBec.foto}
                  style={{
                    height: 200,
                    width: 200,
                    marginTop: "2px",
                    border: "5px solid rgba(10, 49, 67, 1)",
                    objectFit: "cover", // Ajusta la imagen al tamaño del contenedor
                    display: "block", // Comportamiento de bloque para centrar la imagen
                    marginLeft: "auto", // Centra la imagen horizontalmente
                    marginRight: "auto", // Centra la imagen horizontalmente
                  }}
                  width="100%"
                  onClick={() => abrirCerrarModalFoto()}
                />
              </div>
            )}
            <br />
            <label>Nueva Foto: </label>
            <br />
            <Input
              type="file"
              className="form-control"
              accept="archivo_foto/*"
              onChange={(e) => setImagenP(e.target.files[0])}
              multiple
            />
            <br />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn btn-success"
            size="lg"
            onClick={() => peticionPuti()}
          >
            Modificar
          </Button>
          <Button
            color="danger"
            size="lg"
            onClick={() => abrirCerrarModalFoto()}
          >
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
      {/* MODAL FECHA */}
      <Modal isOpen={modalFecha} toggle={abrirCerrarModalFecha}>
        <ModalHeader className="header_mo">Entrega Informes</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <Label>Fecha Establecida: </Label>
            <h2 className="text-center">"{fec.fecha}"</h2>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            size="lg"
            onClick={() => abrirCerrarModalFecha()}
          >
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      {/* Modal para mostrar el comunicado */}
      <Modal isOpen={modalCom} toggle={abrirModalDesdeAlert} size="xl">
        {comunicadoMostrado && (
          <>
            <ModalHeader className="header_mo">
              {comunicadoMostrado.nom_doc}
            </ModalHeader>
            <ModalBody>
              <Card>
                <CardBody className="p-0">
                  <Row className="justify-content-center">
                    <object
                      data={
                        "data:application/pdf;base64," +
                        comunicadoMostrado.archivo_com
                      }
                      type="application/pdf"
                      width="100%"
                      height="600"
                    >
                      <p>
                        Tu navegador no puede mostrar este archivo PDF. Puedes
                        descargarlo{" "}
                        <a
                          href={
                            "data:application/pdf;base64," +
                            comunicadoMostrado.archivo_com
                          }
                          download={comunicadoMostrado.nom_doc}
                        >
                          aquí
                        </a>
                        .
                      </p>
                    </object>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
            <ModalFooter>
              <Button
                color="success"
                size="lg"
                onClick={() => {
                  const link = document.createElement("a");
                  link.href =
                    "data:application/pdf;base64," +
                    comunicadoMostrado.archivo_com;
                  link.download = comunicadoMostrado.nom_doc;
                  link.click();
                }}
              >
                <FaIcons.FaDownload /> Descargar
              </Button>
              <Button
                color="danger"
                size="lg"
                onClick={() => abrirModalDesdeAlert()}
              >
                Cerrar
              </Button>
            </ModalFooter>
          </>
        )}
      </Modal>
      {/* Modal VER MANUAL USUARIO*/}
      <Modal
        isOpen={modalVerManual}
        toggle={abrirCerrarModalVerManual}
        size="xl"
      >
        <ModalHeader className="header_mo">Manual Usuario Becario</ModalHeader>
        <ModalBody>
          <Card>
            <CardBody className="p-0">
              <Row className="justify-content-center">
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "500px",
                  }}
                >
                  <object
                    data={require("../../Pages/Admin/documentos/manuales/MANUAL USUARIO BECARIO.pdf")}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                  >
                    <p>
                      Este navegador no soporta PDFs. Por favor,
                      <a
                        href={require("../../Pages/Admin/documentos/manuales/MANUAL USUARIO BECARIO.pdf")}
                      >
                        {" "}
                        descarga el PDF
                      </a>{" "}
                      para verlo.
                    </p>
                  </object>
                </div>
              </Row>
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button
            style={{ float: "right" }}
            color="success"
            size="lg"
            onClick={handleDownloadPdf}
          >
            <FaIcons.FaDownload />
            Descargar
          </Button>
          <Button
            color="danger"
            size="lg"
            onClick={() => abrirCerrarModalVerManual()}
          >
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      {/* Modal VER CONVOCATORIA */}
      <Modal isOpen={selectedItem !== null} toggle={closeBtn} size="xl">
        {selectedItem && (
          <>
            <ModalHeader className="header_mo">
              {selectedItem.nom_doc}
            </ModalHeader>
            <ModalBody>
              <Card>
                <CardBody className="p-0">
                  <Row className="justify-content-center">
                    <object
                      data={
                        "data:application/pdf;base64," +
                        selectedItem.archivo_com
                      }
                      type="application/pdf"
                      alt="archivo_per"
                      width="400"
                      height="600"
                    >
                      <p>
                        Tu navegador no puede mostrar este archivo PDF. Puedes
                        descargarlo
                        <a
                          href={
                            "data:application/pdf;base64," +
                            selectedItem.archivo_com
                          }
                          download
                        >
                          aquí
                        </a>
                        .
                      </p>
                    </object>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
            <ModalFooter>
              <Button
                style={{ float: "right" }}
                color="success"
                size="lg"
                onClick={handleDescargarPdf}
              >
                <FaIcons.FaDownload />
                Descargar
              </Button>
              <Button color="danger" size="lg" onClick={() => closeBtn()}>
                Cerrar
              </Button>
            </ModalFooter>
          </>
        )}
      </Modal>
      <Outlet />
    </div>
  );
}

export default NavbarBec;
